import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { RoleGroupTable } from "./roleGroup/RoleGroupTable";

const SecurityDashboard = Loadable(
	lazy(() =>
		import("./CreateSecurityGroup").then(({ CreateSecurityGroup }) => ({
			default: CreateSecurityGroup,
		}))
	)
);

const ListSecurityGroups = Loadable(
	lazy(() =>
		import("./ListSecurityGroups").then(({ ListSecurityGroups }) => ({
			default: ListSecurityGroups,
		}))
	)
);

export const securityRoutes = [
	{
		path: "/list-security-groups",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.SECURITY]}>
				<ListSecurityGroups />
			</AuthorizedRoute>
		),
	},

	{
		path: "/create-security-group",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.SECURITY]}>
				<SecurityDashboard />
			</AuthorizedRoute>
		),
	},
	{
		path: "/create-security-group/:roleId",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.SECURITY]}>
				<SecurityDashboard />
			</AuthorizedRoute>
		),
	},
	{
		path: "/secuirty-role-duplicate/:roleId",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.SECURITY]}>
				<SecurityDashboard isDuplicate />
			</AuthorizedRoute>
		),
	},

	{
		path: "/security/role-groups",
		exact: true,
		element: (
			<AuthorizedRoute moduleIds={[ALLOWED_MODULES.SECURITY]}>
				<RoleGroupTable />
			</AuthorizedRoute>
		),
	},
];
